class HHStickyATC extends HTMLElement {

  constructor() {
    super()

    this.formSelector = this.getAttribute('data-form-selector');
  }

  connectedCallback() {
    const formId = document.querySelector(this.formSelector)?.getAttribute('id');
    if (formId) {
      this.querySelector('button[type="submit"]')?.setAttribute('form', formId);
    }
    if (this.originCTA) window.addEventListener('scroll', this.onScroll.bind(this))
  }

  onScroll() {
    if (this.isInViewport(this.originCTA)) {
      this.classList.add('visually-hidden')
    } else {
      this.classList.remove('visually-hidden')
    }
  }

  isInViewport(element) {
    const rect = element.getBoundingClientRect()
    const documentStyle = getComputedStyle(document.documentElement)
    const topOffset = parseInt(documentStyle.getPropertyValue('--announcement-height') || '0')
      + parseInt(documentStyle.getPropertyValue('--header-height') || '0') - element.offsetHeight
    return (rect.top >= topOffset && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight))
  }

  get originCTA() {
    return document.querySelector('.js-main-cta-wrapper')
  }
}

customElements.define('hh-sticky-atc', HHStickyATC)
